import '../App.css';
import React from 'react';
import { write } from '../store'
import Lottie from "lottie-react";
import soundWave from '../assets/soundwave.json'
import playbutton from '../assets/playbutton.json'

let listeningTimer

export function getListeningDurationSeconds(audioElement) {
  const duration = Number(audioElement?.duration)

  if (!Number.isFinite(duration) || duration <= 0) {
    return 60
  }

  return Math.ceil(duration)
}

function Listening({ dataPath }) {
  const [clicked, setClicked] = React.useState(false);
  const [hideAudio, setHideAudio] = React.useState(false);
  const audioRef = React.useRef()


  React.useEffect(() => {
    listeningTimer && clearTimeout(listeningTimer)
    write.stopTimer = true // the timer stops and resumes after the person is done hearing the questions.
    const forceTimeOut = setTimeout(() => {
      handleClick()
    }, 120000); // this should be 120000
    return () => {
      // 👇️ clear timeout when the component unmounts
      clearTimeout(forceTimeOut);
    };
  }, []);


  function handleClick() {
    setClicked(true)
    const duration = getListeningDurationSeconds(audioRef.current)
    // console.log(~~audioRef.current.duration * 1000 , audioRef.current , `${process.env.REACT_APP_DOMAIN}${dataPath}`)
    audioRef.current.play()
    listeningTimer = setTimeout(() => {
      write.stopTimer = false
      setHideAudio(true)
    }, duration * 1000);
  }

  return (
    <>
      {
        clicked ? <Lottie className={`${hideAudio && 'hidden'} w-20 self-center sm:w-24`} animationData={soundWave} loop={true} /> : <button className='self-center rounded-3xl bg-blue-50 p-2 transition-transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-100' ><Lottie className='w-20 sm:w-24' animationData={playbutton} loop={true} onClick={handleClick} /></button>
      }
      <audio className=' hidden' ref={audioRef} controls id="testTone" preload="metadata">
        <source src={`${process.env.REACT_APP_DOMAIN}${dataPath}`} type="audio/mp3" />
      </audio>
    </>
  );
}

export default Listening;
